const bodyapresentationcontent = [
{
    id:0,
    title:"Apresentação",
    corpo:"Olá, Meu nome é Ramon, tenho 31 anos e estou em busca de uma oportunidade para entrar no mercado de trabalho na área de TI. Como estudante Full stack, estou entusiasmado em contribuir com minhas habilidades e experiências para o desenvolvimento de aplicativos. Até o momento, tenho conhecimento em framework ReactJS, experiência com HTML, CSS, JavaScript e Python. Procuro projetos que irão estender minhas habilidades técnicas.",    
    corpo2:""
},
{
    id:1,
    title:"Apresentation",    
    corpo:"Hi, my name is Ramon, I am 31 years old and I am looking for an opportunity to enter the job market in the field of IT. As a Full stack student, I am excited to contribute my skills and experiences to application development. So far, I have knowledge of ReactJS framework, experience with HTML, CSS, JavaScript and Python. I look for projects that will extend my technical skills.",
    corpo2:""
},

]

export default bodyapresentationcontent